const TriggerInput = ({ executeRequest }) => {
  return (
    <section className="trigger-input-section">
      <input
        autoFocus
        type="text"
        className="trigger-input-text"
        placeholder="Press Enter to Search"
        disabled
      />
    </section>
  );
};

export default TriggerInput;
